(ns frontend.view.entity-merge.components
  (:require [frontend.utils :as fu]
            [reagent.core :as r]))

(defmulti step-info
  (fn [_signals [step-kw _step-params]]
    step-kw))

(defmethod step-info :default [_signals [step-kw _step-params]]
  (str "TODO implement info for step " step-kw))

(defn toggle-collapse! [state path]
  (swap! state update-in path not))

(defn review-card [{:keys [state] :as signals} {:keys [collapsed-path title content]}]
  (let [collapsed? (get-in @state collapsed-path)]
    [:div.card-container-inner
     [:div.card-container__header
      {:on-click (r/partial toggle-collapse! state collapsed-path)}
      [:div.d-flex.sm-flex
       [:span.entity-module-header-content.d-flex.align-items-center.pointer
        [:div.mr-2 title]
        (if collapsed?
          [:i.far.fa-chevron-right.collapse-icon]
          [:i.far.fa-chevron-down.collapse-icon])]]]
     [:div
      {:class-name (fu/cs "card-container-inner__body"
                          (when collapsed?
                            "collapsed"))}
      content]]))
